const appConfig = window.app || {};
export function getAppConfig(selector) {
  return selector instanceof Function
    ? selector?.(appConfig)
    : appConfig[selector];
}

export const isDemoEnabled = !!getAppConfig("demo")
export const captchaEnabled = getAppConfig(({captcha})=>captcha?.captchaEnabled) 